@if (title) {
  <h2>{{title}}</h2>
}
<div class="user-details-form" [formGroup]="form">
  <mat-form-field appearance="outline">
    <mat-label>{{ 'user.email.label' | translate }}</mat-label>
    <input matInput name="userEmail" formControlName="email" [readonly]="form.get('id').value !== null">
    @if (form.get('email').invalid) {
      <mat-error>
        @if (form.get('email').errors[ 'required' ]) {
          {{ 'user.email.required' | translate }}
        }
        @if (form.get('email').errors[ 'email' ]) {
          {{ 'user.email.invalid' | translate }}
        }
      </mat-error>
    }
  </mat-form-field>
  @if (( isManagement$ | async )) {
    <mat-form-field appearance="outline">
      <mat-label>{{ 'user.role.label' | translate }}</mat-label>
      <mat-select formControlName="user_role">
        <mat-option value="user">{{ 'user.role.user' | translate }}</mat-option>
        <mat-option value="reader">{{ 'user.role.reader' | translate }}</mat-option>
        @if (isAdmin$ | async) {
          <mat-option value="administrator">{{ 'user.role.admin' | translate }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  <div class="options">
    <mat-checkbox name="user_active" formControlName="active">{{ 'user.active.label' | translate }}</mat-checkbox>
    <!-- DoenKids-controlled. Written by the form's save button through its own
         route, since ai_enabled is excluded from the user update's whitelist. -->
    @if ((isAdmin$ | async) && canEditAiEnabled) {
      <mat-checkbox
        name="user_ai_enabled"
        [checked]="aiEnabled"
        [disabled]="savingAiEnabled"
        [matTooltip]="'user.ai_enabled.tooltip' | translate"
        (change)="toggleAiEnabled($event.checked)"
      >
        {{ 'user.ai_enabled.label' | translate }}
      </mat-checkbox>
    }
    <ng-content></ng-content>
  </div>
</div>
